/** One product deployed in one environment; every monitoring call is scoped to it. */
export interface Target {
  product: string
  environment: string
}

export const targetLabel = ({ product, environment }: Target) => `${product} · ${environment}`

export const formatCount = (value: number) => value.toLocaleString('en-GB')

/** Identity of a queue across fetches; names are only unique within a storage. */
export const queueKey = (queue: { storage: string; name: string }) => `${queue.storage}/${queue.name}`
